import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/DesignSystem'

const DesignSystem: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'デザインシステム　デザインガイドライン　コンポーネントライブラリ　UIデザイン　デザイン原則'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/designsystem/'}
        title="デザインシステム | サービス | Aitria（アイトリア）"
        description="今なぜデザインシステムが必要とされているのか？Aitria（アイトリア）では、ユーザーに素早く価値を届けるためのデザインシステム構築支援サービスを提供しております。"
      />
      <Template />
    </>
  )
}

export default DesignSystem
